export const states = {
  a: 'a',
  b: 'b',
  c: 'c',
};

export const animationInterval = 4000;
